import { render, staticRenderFns } from "./_info.vue?vue&type=template&id=492cf996&scoped=true"
import script from "./_info.vue?vue&type=script&lang=js"
export * from "./_info.vue?vue&type=script&lang=js"
import style0 from "./_info.vue?vue&type=style&index=0&id=492cf996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492cf996",
  null
  
)

export default component.exports